import {Query} from "tick-knock";
import {CapitalView} from "@game/coregame/view/CapitalView";

export const AllBuildingsQuery = new Query(entity => entity.has(CapitalView));
